export default __webpack_public_path__ + "static/media/logo-animation.ead8479b.mov";